import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { CSVLink } from "react-csv";
import Image from "mui-image";
import csv from "src/img/csv.png";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import barChart from "src/img/columns.png";
import cake from "src/img/cake.png";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import "chartjs-plugin-datalabels";
import { CanvasJSChart } from "canvasjs-react-charts";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DatePicker from "react-datepicker";
import RowDetails from "src/components/ReportHistory/reportHistoryRowDetails";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "react-datepicker/dist/react-datepicker.css";
import GeneratePDFContainer from "../GeneratePDFContainer";
import { ReportsColumnFields } from "src/util/utility_enums";
import pdf from 'src/img/pdf.png';
import { getReport } from "src/apis/tickets";
Chart.register(...registerables);

const DataGridComponent = ({ rows, orgName,pdfGenerate }) => {
  const [openDialogs, setOpenDialogs] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [showMainDataGrid, setShowMainDataGrid] = useState(true);

  const handleCakeButtonClick = (rowData) => {
    setOpenDialogs((prevState) => ({
      ...prevState,
      [rowData.id]: true, // Open dialog for the selected row
    }));
  };

  const handleCloseDialog = (rowId) => {
    setOpenDialogs((prevState) => ({
      ...prevState,
      [rowId]: false, // Close dialog for the selected row
    }));
  };

  const [openBarChartDialogs, setOpenBarChartDialogs] = useState({});

  const handleBarChartButtonClick = (rowData) => {
    setOpenBarChartDialogs((prevState) => ({
      ...prevState,
      [rowData.id]: true, // Open bar chart dialog for the selected row
    }));
  };

  const handleConfirmButton = () => {
    setIsOpen(false);
  };
  const calculateTotalCost = () => {
    return rows.reduce((acc, row) => {
      const cost = parseFloat(row.cost);
      if (!isNaN(cost)) {
        return acc + cost;
      }
      return acc;
    }, 0);
  };

  const totalCost = calculateTotalCost();
  const handleCloseBarChartDialog = (rowId) => {
    setOpenBarChartDialogs((prevState) => ({
      ...prevState,
      [rowId]: false, // Close bar chart dialog for the selected row
    }));
  };

  const preparePieChartData = (row) => {
    const cost = parseFloat(row.cost);

    if (!isNaN(cost) && totalCost) {
      const percentage = (cost / totalCost) * 100;
      return [
        {
          label: "Cost",
          value: percentage.toFixed(2),
          color: "rgb(73, 150, 238)",
        },
        {
          label: "Remaining",
          value: 100 - percentage.toFixed(2),
          color: "#282B30",
        },
      ];
    }
    return [];
  };

  const [selectedRow, setSelectedRow] = useState(null);

  const handleRowClick = (event, row) => {
    // Check if the click target has the "chart-button" class (buttons in the last column)
    if (!event.target.classList.contains("chart-button")) {
      setShowMainDataGrid(false);
      setSelectedRow(row);
      console.log(row.id);
    }
  };

  const handleBackButton = () => {
    setShowMainDataGrid(true);
    setSelectedRow(false);
  };

  const columns = [
    { field: "asset", headerName: "Asset", flex: 1 },
    { field: "site", headerName: "Site", flex: 1 },
    { field: "ticket", headerName: "Ticket", flex: 1 },
    { field: "timeSpent", headerName: "Time spent to solve it", flex: 1 },
    { field: "cost", headerName: "Cost", flex: 1 },
    {
      field: "chart",
      headerName: "Chart",
      flex: 1,
      className: "chart-button",
      renderCell: (params) => (
        <div className="chart-button">
          <ButtonPolicy
            className="chart-button"
            onClick={() => handleCakeButtonClick(params.row)}
          >
            <Image src={cake} className="chart-button" />
          </ButtonPolicy>
          <ButtonPolicy
            className="chart-button"
            onClick={() => handleBarChartButtonClick(params.row)}
          >
            <Image src={barChart} className="chart-button" />
          </ButtonPolicy>
        </div>
      ),
    },
  ];

  // Prepare data for CSV export
  const csvData = rows && rows.length ? rows.map((row) => ({
    site: row.site,
    asset: row.asset,
    ticket: row.ticket,
    timeSpent: row.timeSpent,
    cost: row.cost,
    chart: row.chart,
  })) : [];
  
  // Calculate the sum of each column
  const columnSums = {};
  columns.forEach((column) => {
    const fieldName = column.field;
    switch (fieldName) {
      case ReportsColumnFields.SITE:
        columnSums[fieldName] = orgName ?? "";
        break;
      case ReportsColumnFields.TICKET:
        columnSums[fieldName] = rows.reduce(
          (acc, row) => acc + Number(row[fieldName]),
          0
        );
        break;
      case ReportsColumnFields.TIMESPENT:
        const totalHours = rows.reduce((acc, row) => {
          const hours = parseFloat(row[fieldName]);
          if (!isNaN(hours)) {
            return acc + hours;
          }
          return acc;
        }, 0);
        columnSums[fieldName] = totalHours;
        break;
      case ReportsColumnFields.COST:
        const totalCost = rows.reduce((acc, row) => {
          const cost = parseFloat(row[fieldName]);
          if (!isNaN(cost)) {
            return acc + cost;
          }
          return acc;
        }, 0);
        columnSums[fieldName] = totalCost;
        break;
      default:
        columnSums[fieldName] = "";
        break;
    }
  });

  return (
    <div style={{ width: "100%", marginBottom: 15 }}>
      {showMainDataGrid && (
        <div>
          <div className="datePicker">
            <span onClick={() => setIsOpen(!isOpen)}>
              <CalendarTodayIcon />
            </span>
            <span>
              {" "}
              {startDate.toLocaleDateString("en-GB", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              })}{" "}
              -
              {endDate.toLocaleDateString("en-GB", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              })}
            </span>
          </div>
          {isOpen && (
            <div className="dateDropdown">
              <div className="startDatePicker">
                <span className="fromTo">From:</span>{" "}
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  dateFormat="dd/MM/yyyy"
                />
              </div>
              <div className="endDatePicker">
                <span className="fromTo">To:</span>{" "}
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                />
              </div>
              <div className="confirmButton" onClick={handleConfirmButton}>
                <ButtonPolicy color="primary" >
                  Confirm
                </ButtonPolicy>
              </div>
            </div>
          )}
          <DataGrid
            className="reportDataGrid"
            columns={columns}
            rows={rows}
            pagination
            onRowClick={(params, event) => handleRowClick(event, params.row)}
          />
          {rows&& rows.length>0 && rows.map((row) => (
            <Dialog
              key={row.id}
              open={openDialogs[row.id] || false}
              onClose={() => handleCloseDialog(row.id)}
            >
              <DialogTitle> </DialogTitle>
              <DialogContent>
                {openDialogs[row.id] && (
                  <CanvasJSChart
                    className="my-chart"
                    options={{
                      animationEnabled: true,
                      title: {
                        text: `Pie Chart for ${row.site} : ${row.asset}`,
                        fontColor: "#fff",
                      },
                      backgroundColor: "#07070e",

                      data: [
                        {
                          type: "pie",
                          showInLegend: true,
                          toolTipContent: "{label}: <strong>{y}%</strong>",
                          indexLabel: "{label} ({y}%)",
                          indexLabelPlacement: "inside", // or 'outside'
                          dataPoints: (preparePieChartData(row) || []).map((item) => ({
                            y: item.value,
                            legendText: item.label,
                            label: item.label,
                            color: item.color,
                            indexLabelFontColor: "#fff",
                          })),
                        },
                      ],
                    }}
                  />
                )}
              </DialogContent>
              <DialogActions>
                <ButtonPolicy
                  onClick={() => handleCloseDialog(row.id)}
                  color="primary"
                >
                  Close
                </ButtonPolicy>
              </DialogActions>
            </Dialog>
          ))}
          {rows && rows.length>0 && rows.map((row) => (
            <Dialog
              key={row.id}
              open={openBarChartDialogs[row.id] || false}
              onClose={() => handleCloseBarChartDialog(row.id)}
            >
              <DialogTitle>
                Bar Chart for {row.site} : {row.asset}
              </DialogTitle>
              <DialogContent>
                {openBarChartDialogs[row.id] && (
                  <Bar
                    data={{
                      labels: ["Number of Tickets", "Total Tickets"],
                      datasets: [
                        {
                          label: "Tickets",
                          backgroundColor: "rgb(73, 150, 238)",
                          borderColor: "rgb(73, 150, 238)",
                          borderWidth: 1,
                          data: [
                            Number(row.ticket),
                            rows.reduce(
                              (acc, currRow) => acc + Number(currRow.ticket),
                              0
                            ),
                          ],
                        },
                      ],
                    }}
                    options={{
                      scales: {
                        y: {
                          beginAtZero: true,
                        },
                      },
                    }}
                  />
                )}
              </DialogContent>
              <DialogActions>
                <ButtonPolicy
                  onClick={() => handleCloseBarChartDialog(row.id)}
                  color="primary"
                >
                  Close
                </ButtonPolicy>
              </DialogActions>
            </Dialog>
          ))}
          <div className="totalAmount">
            <table>
              <tbody>
                <tr>
                  <td>Total:</td>
                  <td>{columnSums.site}</td>
                  <td>{columnSums["ticket"]} Tickets</td>
                  <td>{columnSums["timeSpent"].toFixed(2)} Hours</td>
                  <td>{columnSums["cost"].toFixed(2)} €</td>
                  <td>
                    <div className='csvImageHolder'>
                      <Image src={pdf} onClick={pdfGenerate}/>
                    </div>
                  </td>
                  <td>
                  <span className="excelFile">
                      <CSVLink
                        data={csvData}
                        headers={columns.map((column) => ({
                          label: column.headerName,
                          key: column.field,
                        }))}
                      >
                        <div className="csvImageHolder">
                          <Image src={csv} />
                        </div>
                      </CSVLink>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
      {selectedRow && (
        <div>
          <span className="backButton" onClick={() => handleBackButton()}>
            <ArrowBackIcon />
          </span>
          <RowDetails rowData={selectedRow} />
        </div>
      )}
    </div>
  );
};

const ReportsHistoryMaintenance = ({ props }) => {
  const orgName = props && props.length > 0 ? props.map((item) => item.orgName)[0] : null;
  const rows = props && props.length > 0 ? props.map((item)=> ({
    id: item.assetId,
    site: item.siteName,
    asset: item.assetName,
    ticket: item.numbers,
    timeSpent: item.totTimeSpentToSolve,
    cost:
      item.totFeeAmountProposal !== null ? item.totFeeAmountProposal : "N.A",
  })) : [];

const fetchReport = async () => {
        
  try {
     await getReport()
 } catch (error) {
    console.error(error);
  }
};
return (
    <div className="datagrid-container">
      <DataGridComponent rows={rows} orgName={orgName} pdfGenerate={fetchReport} />
    </div>
  );
};

export default ReportsHistoryMaintenance;
